<script setup lang="ts">
import Header from '~/components/layout/header.vue';
import Footer from '~/components/layout/footer.vue';


</script>

<template>
  <div class="wrap">
    <Header :show-bread-crumb="false" />
      <div class="content">
        <NuxtPage />
      </div>
    <Footer />
  </div>
</template>

<style scoped>

</style>